import { render, staticRenderFns } from "./handle-record.vue?vue&type=template&id=70ca0401&scoped=true"
import script from "./handle-record.vue?vue&type=script&lang=js"
export * from "./handle-record.vue?vue&type=script&lang=js"
import style0 from "./handle-record.vue?vue&type=style&index=0&id=70ca0401&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ca0401",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70ca0401')) {
      api.createRecord('70ca0401', component.options)
    } else {
      api.reload('70ca0401', component.options)
    }
    module.hot.accept("./handle-record.vue?vue&type=template&id=70ca0401&scoped=true", function () {
      api.rerender('70ca0401', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/detail-pane/components/handle-record.vue"
export default component.exports